import { render } from "./WorkStationCardCompact.vue?vue&type=template&id=17b9d433&scoped=true"
import script from "./WorkStationCardCompact.vue?vue&type=script&lang=js"
export * from "./WorkStationCardCompact.vue?vue&type=script&lang=js"

import "./WorkStationCardCompact.vue?vue&type=style&index=0&id=17b9d433&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b9d433"]])

export default __exports__